import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SmartphotoImage } from '@bdeo-motor/smartphoto-entities';
import { firstValueFrom } from 'rxjs';
import { SmartphotoService } from '../../../../services/smartphoto.service';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-smartphoto-pictures-gallery-dialog',
  templateUrl: './smartphoto-pictures-gallery-dialog.component.html',
  styleUrl: './smartphoto-pictures-gallery-dialog.component.scss'
})
export class SmartphotoPicturesGalleryDialog implements AfterViewInit, OnDestroy {
  @ViewChild('swiper') swiper!: ElementRef<SwiperContainer>;
  @ViewChild('currentImage') currentImage!: ElementRef;

  private readonly smartphotoService = inject(SmartphotoService);
  private readonly dialogRef = inject(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);

  public images$ = this.smartphotoService.get.images();
  public index: number = this.data.initialSlide;
  public loadingDownload = false;

  public ngAfterViewInit(): void {
    this.swiper.nativeElement.swiper.activeIndex = this.index;
    this.swiper.nativeElement.addEventListener('swiperslidechange', () => {
      this.setIndexFromSwiper();
    });
  }

  private setIndexFromSwiper(): void {
    this.index = this.swiper.nativeElement.swiper.activeIndex;
  }

  async downloadImage(): Promise<void> {
    try {
      this.loadingDownload = true;
      const images: SmartphotoImage[] = await firstValueFrom(this.images$);
      const imageURL = images[this.index].url;
      const imageName = images[this.index].caption || 'image.jpg';
      this.smartphotoService.downloadImage(imageURL, imageName);
    } catch (error) {
      console.error('Error downloading image:', error);
    } finally {
      this.loadingDownload = false;
    }
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  public ngOnDestroy(): void {
    this.swiper.nativeElement.removeEventListener('swiperslidechange', () => {
      this.setIndexFromSwiper();
    });
  }
}
